import { ProjectTab } from './project-detail.types';

interface Tab {
  id: ProjectTab;
  label: string;
}

interface Props {
  tabs: Tab[];
  activeTab: ProjectTab;
  onTabChange: (tab: ProjectTab) => void;
}

const ProjectTabBar = ({ tabs, activeTab, onTabChange }: Props) => (
  <div className="flex border-b border-border-subtle overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        onClick={() => onTabChange(tab.id)}
        className={`px-4 py-3 text-sm whitespace-nowrap shrink-0 border-b-2 transition-colors cursor-pointer ${
          activeTab === tab.id
            ? 'border-brand-vivid text-text-default font-medium'
            : 'border-transparent text-text-subtle hover:text-text-default'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default ProjectTabBar;
